import {Model} from '../Models';

/**
 * Marker class for objects being transferred to the REST API.
 * As those object might differ from normal entities (different fields or data formats), those are handled differently.
 * Use DTOs to encapsulate the data edited in a form.
 */
export abstract class DataTransferObject {

  /**
   * Map the data from a model instance to the corresponding DTO class.
   * @param model
   */
  abstract fromModel(model: Model): DataTransferObject;
}
